export let JobFieldOption;

(function (JobFieldOption) {
  JobFieldOption["Sales"] = "sales";
  JobFieldOption["Marketing"] = "marketing";
  JobFieldOption["Support"] = "services-support";
  JobFieldOption["Admin"] = "administration-operations";
  JobFieldOption["Other"] = "other";
})(JobFieldOption || (JobFieldOption = {}));